import { render } from "./college-order-detail.vue?vue&type=template&id=5654afca"
import script from "./college-order-detail.vue?vue&type=script&lang=js"
export * from "./college-order-detail.vue?vue&type=script&lang=js"

import exportComponent from "/data/soft/jenkins/jobs/release-ms-front/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__